import { ChangeHook, EnterHook, RedirectFunction, RouterState } from "react-router";

// This is an adapeter that lets us call existing middleware from `onChange` instead of `onEnter`, which has a different signature.
export const wrapOnChange = (onEnterCallback: EnterHook): ChangeHook => {
    return (_prevState: RouterState, nextState: RouterState, replace: RedirectFunction, callback: AnyFunction) =>
        onEnterCallback(nextState, replace, callback);
};
